"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeEventMap = exports.ClearStoreEvent = exports.SetItemEvent = exports.RemoveItemEvent = exports.BaseTypeMap = void 0;
const eventBusBasic_1 = require("../../eventBus/eventBusBasic");
var BaseTypeMap;
(function (BaseTypeMap) {
    BaseTypeMap["REMOVE"] = "REMOVE";
    BaseTypeMap["CLEAR"] = "CLEAR";
    BaseTypeMap["SET"] = "SET";
})(BaseTypeMap || (exports.BaseTypeMap = BaseTypeMap = {}));
class RemoveItemEvent extends eventBusBasic_1.Event {
}
exports.RemoveItemEvent = RemoveItemEvent;
class SetItemEvent extends eventBusBasic_1.Event {
}
exports.SetItemEvent = SetItemEvent;
class ClearStoreEvent extends eventBusBasic_1.Event {
}
exports.ClearStoreEvent = ClearStoreEvent;
exports.TypeEventMap = {
    [BaseTypeMap.CLEAR]: ClearStoreEvent,
    [BaseTypeMap.REMOVE]: RemoveItemEvent,
    [BaseTypeMap.SET]: SetItemEvent,
};
//# sourceMappingURL=types.js.map